"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.root = void 0;

var _util = require("../../../util");

const root = ({
  cssProps = {},
  theme
}) => ({
  border: 0,
  borderBottom: "1px solid ".concat((0, _util.color)(theme, cssProps.color)),
  margin: 0
});

exports.root = root;
//# sourceMappingURL=Divider.style.js.map